import KogCheckbox from "@/main/components/shared/checkbox/kogCheckbox";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";

interface ILockedNotQuoteCheckboxProps {
	id: string;
	checked: boolean;
	tooltipMessage: string;
}

const TOOLTIP_MAX_WIDTH = 260;

export default function LockedNotQuoteCheckbox({ id, checked, tooltipMessage }: ILockedNotQuoteCheckboxProps) {
	return (
		<TooltipComponent
			title={<div style={{ maxWidth: TOOLTIP_MAX_WIDTH, wordBreak: "normal" }}>{tooltipMessage}</div>}
			placement="top"
			enterTouchDelay={0}
		>
			{/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- focusable so the tooltip opens on keyboard focus */}
			<span tabIndex={0} style={{ display: "inline-flex", outline: "none" }}>
				<KogCheckbox id={id} disabled checked={checked} />
			</span>
		</TooltipComponent>
	);
}
